import { render, staticRenderFns } from "./personCenter.vue?vue&type=template&id=b8825d48&scoped=true"
import script from "./personCenter.vue?vue&type=script&lang=js"
export * from "./personCenter.vue?vue&type=script&lang=js"
import style0 from "./personCenter.vue?vue&type=style&index=0&id=b8825d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8825d48",
  null
  
)

export default component.exports